import { AuthenticatedLayout } from "@/components/layout/authenticated-layout";
import { OrganizationProvider } from "@/context/organization-provider";
import { UserProvider } from "@/context/user-provider";
import { OrganizationSubscriptions } from "@/features/core/components/organization-subscriptions";

export const Route = createFileRoute({
  component: () => (
    <UserProvider>
      <OrganizationProvider>
        <OrganizationSubscriptions>
          <AuthenticatedLayout />
        </OrganizationSubscriptions>
      </OrganizationProvider>
    </UserProvider>
  ),
});
